import FilterGrainImage from 'src/shared/assets/images/filter-grain.png'
import FilterGrainWebp from 'src/shared/assets/images/filter-grain.webp'
import { cn } from 'src/shared/utils/cn'

/** A filter grain overlay that can be used to add a grainy effect to an image.
 * Should be used as a child of an element that has a position: relative.
 */
export default function FilterGrain({ className }: { className?: string }) {
  return (
    <picture className={cn('pointer-events-none absolute inset-0', className)}>
      <source type="image/webp" srcSet={FilterGrainWebp} />
      <img src={FilterGrainImage} className="size-full object-cover" />
    </picture>
  )
}
